import { createLabeledMessages } from '../../../messageUtils';
const delegationsLight = {
    cancel: 'Zrušit',
    setDelegation: 'Nastavit zástup',
    delegation: 'Zástup'
};
export default Object.assign({}, delegationsLight, createLabeledMessages(delegationsLight));
